<template>
  <v-combobox
    v-model="val"
    :items="items"
    :label="label || title"
    chips
    clearable
    multiple
  >
  <template slot="selection" slot-scope="data">
    <v-chip
      :selected="data.selected"
      close
      @input="remove(data.item)"
      small
    >
      {{ data.item }}
    </v-chip>
  </template>
</v-combobox>
</template>
<script>
import {EventMixin} from '@/lib/mixins.js';
export default {
  mixins: [EventMixin],
  props: {
    'value': {
      type: Object,
      default () { return {}; }
    },
    'name': String,
    'label': String,
    'title': String,
    'items': {
      type: Array,
      default () { return []; }
    }
  },
  computed: {
    val: {
      get () {
        var val = _.get(this.value, this.name) || "";
        return (_.isEmpty(val) ? [] : val.split(","))
      },
      set (val) {
        var value = _.cloneDeep(this.value);
        _.set(value, this.name, val.join(","));
        this.$emit("input", value);
      }
    }
  },
  methods: {
    remove (item) {
      this.val.splice(this.val.indexOf(item), 1)
      this.val = [...this.val]
    }
  }
}
</script>
